import type { FaireProductEntity } from "../../entity_types/product";

export const p_wet5rn7gxb: FaireProductEntity = {
  token: "p_wet5rn7gxb",
  type: "product",
  name: "Ghost Lake Luxe Handmade Incense",
  brandToken: "b_pzsmxvxzjh",
  brandName: "Brass Earth",
  imageUrl:
    "https://cdn.faire.com/fastly/6350804031e8c8771820a9d231f1d0dd9864c6b96eded13d99a5b60661f97d91.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/90b2bdc9bb4a4d58a4dbb3c524a0b7590ed36dcfbd1f517d9786be597afe8138.jpeg",
    "https://cdn.faire.com/fastly/67b6c9a236dc3c92834176e330891029a933f3406cbdcb13cc2a5784c50b6fc7.jpeg",
    "https://cdn.faire.com/fastly/fa8f5cae73581a47d40d03dfc09c5384d379a770f2df152e81fbcb444c783644.png",
    "https://cdn.faire.com/fastly/5d4019cf0e492ea932bf62066d69549459cda843f2f5e2447437a1821e8b7073.png",
    "https://cdn.faire.com/fastly/4feaaef142d05d50c17b77494850815670ac3a0a4ef9b30f3ade47b48f9a8818.jpeg",
  ],
  priceDollars: 8.9,
  description:
    "These luxurious incense have a cult following in our brick and mortar shop in Columbus, OH. A truly unique scent experience. Lovingly handmade by The Brass Hand/Brass Earth team, with a 1+ hour burn time, lingering fragrance, and addictive aromas, these will be bestsellers for you too. New packaging update: Crescent moon die-cuts for easy sniffing :) All incense orders come with free testers.\n\nGHOST LAKE: A haunting, mineral-rich blend of salt, ozone, bergamot, vetiver, rosewood, and cedar. Inspired by vast salt flats- the ghost of water long gone- this aroma is both expansive and grounding, evoking stillness with a subtle edge of mystery. A bestseller in our shop for its depth and quiet intensity.\n\n15 sticks packaged in gorgeous soft-touch boxes\nOver 1 hour burn time\nCrafted with high-quality aroma oils",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:55:18.114Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
